"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var DataSource_1 = require("../dataSources/DataSource");
var package_json_1 = require("../../../package.json");
var ExecuteAfmAdapter = /** @class */function () {
  function ExecuteAfmAdapter(sdk, projectId) {
    this.projectId = projectId;
    this.sdk = sdk.clone();
    this.sdk.config.setJsPackage("@gooddata/data-layer", package_json_1.version);
  }
  ExecuteAfmAdapter.prototype.createDataSource = function (afm, fingerprint) {
    var _this = this;
    var execFactory = function execFactory(resultSpec) {
      var execution = {
        execution: {
          afm: afm,
          resultSpec: resultSpec
        }
      };
      return _this.sdk.execution.executeAfm(_this.projectId, execution);
    };
    var responseFactory = function responseFactory(resultSpec) {
      var execution = {
        execution: {
          afm: afm,
          resultSpec: resultSpec
        }
      };
      return _this.sdk.execution.getExecutionResponse(_this.projectId, execution);
    };
    var resultFactory = this.sdk.execution.getPartialExecutionResult;
    var dataSource = new DataSource_1.DataSource(execFactory, afm, fingerprint, responseFactory, resultFactory);
    return Promise.resolve(dataSource);
  };
  return ExecuteAfmAdapter;
}();
exports.ExecuteAfmAdapter = ExecuteAfmAdapter;